import {WarehouseTransfer, IWarehouseTransfer} from 'app/blocks/model/inventory-movement.model';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {SERVER_API_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class WarehouseTransferService extends EntityCrudService<IWarehouseTransfer> {
    constructor(http: HttpClient) {
        super(http, Resource.WAREHOUSE_TRANSFERS, (obj?) => new WarehouseTransfer(obj));
    }
    public setApprovedStatusToSelectedWarehouse = (warehouseTransferID): any => {
        return this.http
            .post<any>(SERVER_API_URL + 'api/warehouse-transfers/' + warehouseTransferID + '/approve' + status, null, {observe: 'response'})
            .toPromise();
    };

    public setDispatchStatusToSelectedWarehouseTransfer = (warehouseTransferID): any => {
        return this.http
            .post<any>(SERVER_API_URL + 'api/warehouse-transfers/' + warehouseTransferID + '/dispatch' + status, null, {observe: 'response'})
            .toPromise();
    };

    downloadPDF = (warehouseTransferId: number): any => {
        const REQUEST_URI = `${SERVER_API_URL}api/warehouse-transfers/${warehouseTransferId}/pdf`;
        return this.http.get(REQUEST_URI, {responseType: 'arraybuffer'});
    };

    downloadMergedWarehouseTransferPdfs = (ids: number[]): Promise<any> => {
        const requestParams = new HttpParams().set('ids', ids.toString());
        const REQUEST_URI = `${SERVER_API_URL}api/warehouse-transfers/download`;
        return this.http
            .get(REQUEST_URI, {
                responseType: 'arraybuffer',
                params: requestParams
            })
            .toPromise();
    };
}
